<div class="video-container">
  <mat-sidenav-container>
    <!--navbar main container -->
    <mat-sidenav-content class="navbar-main">
      <button mat-button (click)="sidenav.toggle()" class="navbar-toggle">
        <i class="fa fa-bars fa-lg navbar-toggle-icon" aria-hidden="true"></i>
      </button>
      <div class="video-feed" *ngIf="selectedVideoFeed !== null">
        <div class="player-view" *ngIf="videoStreamService.videoSourceOne.url">
          <div
            class="video-control-bar"
            [class.disabled]="videoStreamService.videoSourceOne.invalidUrl"
          >
            <i
              class="fa ctrl-icon"
              [class.fa-volume-off]="playerUi.muted"
              [class.fa-volume-up]="!playerUi.muted"
              aria-hidden="true"
              (click)="toggleMuted($event)"
              [title]="
                (playerUi.muted ? 'VIDEO_CONTROL.UNMUTE' : 'VIDEO_CONTROL.MUTE')
                  | translate
              "
            ></i>
            <i
              class="fa ctrl-icon"
              [class.fa-compress]="playerUi.objectFit === 'fill'"
              [class.fa-expand]="playerUi.objectFit === 'contain'"
              aria-hidden="true"
              (click)="toggleObjectFit($event)"
              [title]="
                (playerUi.objectFit === 'fill'
                  ? 'VIDEO_CONTROL.FIT_CONTAIN'
                  : 'VIDEO_CONTROL.FIT_FILL'
                ) | translate
              "
            ></i>
          </div>
          <div
            class="sites-video-player"
            *ngIf="
              !videoStreamService.videoSourceOne.invalidUrl &&
              streamEngineServerUrl
            "
          >
            <rse-player
              [serverUrl]="streamEngineServerUrl"
              [url]="asSourceUrl(videoStreamService.videoSourceOne.url)"
              [appToken]="streamAppToken"
              [muted]="playerUi.muted"
              [objectFit]="playerUi.objectFit"
            ></rse-player>
          </div>
          <div
            *ngIf="videoStreamService.videoSourceOne.invalidUrl"
            class="no-video"
          >
            {{ "VIDEO_FEED.INVALID_URL" | translate }}
          </div>
          <div
            *ngIf="
              !videoStreamService.videoSourceOne.invalidUrl &&
              !streamEngineServerUrl
            "
            class="no-video"
          >
            {{ "VIDEO_FEED.NO_VIDEO" | translate }}
          </div>
        </div>
      </div>
      <div *ngIf="!videoStreamService.videoSourceOne.url" class="no-video">
        {{ "VIDEO_FEED.NO_VIDEO" | translate }}
      </div>
    </mat-sidenav-content>

    <!-- navbar side container -->
    <mat-sidenav
      #sidenav
      opened="true"
      mode="over"
      position="end"
      class="navbar-side"
    >
      <div class="video-list">
        <h1>
          <i
            (click)="sidenav.toggle()"
            class="fa fa-arrow-right fa-md navbar-toggle-icon nav-close-icon"
            aria-hidden="true"
          ></i>
          <span class="title">
            {{ "ANALYTICAL_ALARM_HISTORY.VIDEOS" | translate }}
          </span>
        </h1>
        <ul>
          <li
            *ngFor="let video of videoFeeds; let videoNo = index"
            (click)="onVideoSelect(videoNo)"
            [value]="videoNo"
          >
            <div
              class="asset-li"
              [class.selected]="videoNo == selectedVideoFeedNo"
            >
              <a>
                <p class="asset-name">{{ video.name }}</p>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
